
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, signInWithEmailAndPassword, signInAnonymously, createUserWithEmailAndPassword, sendEmailVerification, RecaptchaVerifier, signInWithPhoneNumber, updateProfile, EmailAuthProvider, PhoneAuthProvider, linkWithCredential, linkWithPopup, signInWithCredential } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, getDocs, addDoc, onSnapshot, updateDoc, deleteDoc, collection, serverTimestamp, increment, writeBatch, query, orderBy, limit, where } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCX8qak51BRLG_rGbPatswJQ7Om6Jr_4r8",
  authDomain: "rashid-online-2025.firebaseapp.com",
  projectId: "rashid-online-2025",
  storageBucket: "rashid-online-2025.firebasestorage.app",
  messagingSenderId: "877881200792",
  appId: "1:877881200792:web:05690d23aba0d0ff1c40ed",
  measurementId: "G-Z2RLSNC2EN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1'); // Ensure region matches deployment
const analytics = getAnalytics(app);
const googleProvider = new GoogleAuthProvider();

export {
  auth,
  db,
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
  functions,
  httpsCallable,
  googleProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  signInAnonymously,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  updateProfile,
  EmailAuthProvider,
  PhoneAuthProvider,
  linkWithCredential,
  linkWithPopup,
  signInWithCredential,
  signOut,
  doc,
  setDoc,
  getDoc,
  getDocs,
  addDoc,
  onSnapshot,
  updateDoc,
  deleteDoc,
  collection,
  serverTimestamp,
  increment,
  writeBatch,
  query,
  orderBy,
  limit,
  where
};
